// document.querySelector('#f-search-guests').focus(function(){
//     //open bootsrap modal
//     document.querySelector('#m-search-guests').modal({
//        show: true
//     });
// });

const selectionChangeButton = document.querySelector("#m-selection-btn");

if (selectionChangeButton) {
    selectionChangeButton.addEventListener("click", function() {
        $("#m-selection").modal("show");
    });
}

// document.querySelector('#submit').click(function(){
//     var cities = [],
//         input = document.querySelector('#cities-form').serializeArray();
//     for (i=0; i< input.length; i++) {
//         cities.push(input[i].value);
//     }
//
//     if (cities.length === 0) {
//         document.querySelector('.error').text('please select a city...stupid');
//     } else {
//         document.querySelector('.error').text('');
//     	var data = JSON.stringify(cities);
//     	console.log(data);
//     }
// });